import $ from 'jquery';
import './style.scss';
import './globals'; 
import { chartOptions } from './config';
import i18n from './i18n';
import addChartGradient from './gradient';

import { RateResults, ExchangeRateTuple } from './models/index';

let resizedFinished: number = 0;
const RESIZE_END_DELAY = 250;

$(initialize);

function initialize() : void {
  google.charts.load('current', {
    packages: ['corechart', 'line'],
  });
  showFitlers();
  registerHandlers();
}

function showFitlers() : void {
  const $ratesFilters = $('.exchange-rates--filters');

  if ($ratesFilters.hasClass('hide')) {
    $ratesFilters.removeClass('hide');
  }
}

function registerHandlers() : void {
  const rateGraphFilters = $('select.rate-graph__selector');
  google.charts.setOnLoadCallback(drawBasic);
  rateGraphFilters.on('change', onFiltersChange);
  $(window).on('resize', () => onResize(rateGraphFilters));
}

function drawBasic() : void {
  $('.rate-graph__container').each((idx: number, graphElement: HTMLElement) => {
    const dataTable = new google.visualization.DataTable();
    const chart = new google.visualization.LineChart(graphElement);

    dataTable.addColumn('date', 'X');
    dataTable.addColumn('number', 'Rate');
    google.visualization.events.addOneTimeListener(chart, 'ready', () => addChartGradient(chart));

    loadDataFor(dataTable, chart, chartOptions, graphElement);
  });
}

function loadDataFor(
  dataTable: gv.DataTable, 
  chart: gv.LineChart, 
  options: gv.LineChartOptions, 
  container: HTMLElement,
) : void {
  const from = container.getAttribute('data-currency-from') || '';
  const to = container.getAttribute('data-currency-to') || '';
  const days = container.getAttribute('data-days') || '';
  const base = wpajax.ajaxurl || '/wp-admin/admin-ajax.php';  
  const rateExchange = from + to; 

  $.ajax({
    url: `${base}?action=rates_historic`,
    data: { to, from, days },
    dataType: 'json',
  })
    .done((results) => {
      updateDataTable(results, dataTable, rateExchange);
      updateCurrentRate(results, container, rateExchange);
    })
    .always(() => updateChart(chart, options, dataTable, days));
}

function updateChart(
  chart: gv.LineChart, 
  options: gv.LineChartOptions, 
  dataTable: gv.DataTable, 
  days: string,
) : void {
  const updatedOptions = $.extend({}, options, {
    hAxis: {
      title: i18n.RATE_PERIOD(parseInt(days, 10)),
    },
  });

  chart.draw(dataTable, updatedOptions);
}

function updateCurrentRate(
  results: RateResults, 
  container: HTMLElement, 
  rateExchange: string,
) : void {
  const dates = Object.keys(results);
  const currentRate = results[dates[dates.length - 1]][rateExchange];

  $(container)
    .parent()
    .find('span.rate')
    .text(currentRate.toFixed(4));
}

function updateDataTable(
  results: RateResults, 
  dataTable: gv.DataTable, 
  rateExchange: string,
) : void {
  const mapped = Object.keys(results)
    .reduce(createRateExchangeMap, []);

  function createRateExchangeMap(acc: ExchangeRateTuple[], date: string) {
    const item = results[date];
    if (item[rateExchange]) {
      acc.push([new Date(date), item[rateExchange]]);
    }

    return acc;
  }

  if (mapped.length > 0) {
    dataTable.addRows(mapped);
  }
}

function onFiltersChange() {
  const $filters = $(this);
  applyLoader($filters);
  redrawRateGraph($filters);
}

function onResize($filters: JQuery<HTMLElement>) {
  clearTimeout(resizedFinished);
  applyLoader($filters);
  resizedFinished = setTimeout(() => redrawRateGraph($filters), RESIZE_END_DELAY);
}

function applyLoader($filters: JQuery<HTMLElement>) {
  const container = $filters.parents('.exchange-rates').find('.rate-graph__container');

  if (container.find('.loader').length === 0) {
    const item = $filters.attr('name');
    const value = <string>$filters.val();
    container.html('<div class="loader"></div>');
    container.attr(`data-${item}`, value);
  } 
}

function redrawRateGraph($filters: JQuery<HTMLElement>) : boolean {
  const container = $filters.parents('.exchange-rates').find('.rate-graph__container');
  const data = new google.visualization.DataTable();
  const chart = new google.visualization.LineChart(container[0]);

  data.addColumn('date', 'X');
  data.addColumn('number', 'Rate');

  google.visualization.events.addOneTimeListener(chart, 'ready', () => addChartGradient(chart));
  loadDataFor(data, chart, chartOptions, container[0]);

  return false;
}
